import { render, staticRenderFns } from "./popup-address.vue?vue&type=template&id=024ea17f&scoped=true&"
import script from "./popup-address.vue?vue&type=script&lang=js&"
export * from "./popup-address.vue?vue&type=script&lang=js&"
import style0 from "./popup-address.vue?vue&type=style&index=0&id=024ea17f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ea17f",
  null
  
)

export default component.exports